import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_EXAM_ROOM_ASSIGNMENTS, 
    ADD_NEW_EXAM_ROOM_ASSIGNMENT, 
    UPDATE_EXAM_ROOM_ASSIGNMENT, 
    DELETE_EXAM_ROOM_ASSIGNMENT,
    RESET_EXAM_ROOM_ASSIGNMENT_LAST_ACTION_SUCCESS,

     GENERATE_EXAM_ROOM_SEATS, 
     GET_EXAM_ROOM_SEATS, 
     RESET_EXAM_ROOM_SEATS,

} from "./actionTypes";

import {
    getExamRoomAssignmentsSuccess,
    getExamRoomAssignmentsFail,
    addExamRoomAssignmentSuccess,
    addExamRoomAssignmentFail,
    updateExamRoomAssignmentSuccess,
    updateExamRoomAssignmentFail,
    deleteExamRoomAssignmentSuccess,
    deleteExamRoomAssignmentFail,

    generateExamRoomSeatsSuccess, 
    generateExamRoomSeatsFail,

    getExamRoomSeatsSuccess, 
    getExamRoomSeatsFail,

    resetExamRoomSeatsSuccess, 
    resetExamRoomSeatsFail,
   
} from "./actions"

import {
    getExamRoomAssignments,
    addNewExamRoomAssignment,
    updateExamRoomAssignment,
    deleteExamRoomAssignment,

    generateExamRoomSeats, 
    getExamRoomSeats, 
    resetExamRoomSeats,
   
} from "helpers/exam-room-assignments/exam_room_assignments_backend_helper";
import { toast } from "react-toastify";

function* fetchExamRoomAssignments() {
    try {
        const response = yield call(getExamRoomAssignments)

        yield put(getExamRoomAssignmentsSuccess(response.examRoomAssignments))
    } catch (error) {
        yield put(getExamRoomAssignmentsFail(error))
    }
}

function* onAddNewExamRoomAssignment({ payload }) {
    try {

        
        const response = yield call(addNewExamRoomAssignment, payload)

        yield put(addExamRoomAssignmentSuccess(response.examRoomAssignment))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addExamRoomAssignmentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateExamRoomAssignment({ payload}) {
    try {
        const response = yield call(updateExamRoomAssignment, payload)
        yield put(updateExamRoomAssignmentSuccess(response.examRoomAssignment))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateExamRoomAssignmentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteExamRoomAssignment({ payload: data }) {

    try {
        const response = yield call(deleteExamRoomAssignment, data)
        yield put(deleteExamRoomAssignmentSuccess(response.examRoomAssignmentId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteExamRoomAssignmentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

// ─── Places ───────────────────────────────────────────────────────────────────

function* generateExamRoomSeatsSaga({ payload: uuid }) {
    try {
        const response = yield call(generateExamRoomSeats, uuid);
        yield put(generateExamRoomSeatsSuccess({
            seats: response.seats,
            stats: response.stats,
        }));
        yield put(getExamRoomAssignments()); // recharger pour seats_count
    } catch (error) {
        yield put(generateExamRoomSeatsFail(error));
    }
}

function* getExamRoomSeatsSaga({ payload: uuid }) {
    try {
        const response = yield call(getExamRoomSeats, uuid);
        yield put(getExamRoomSeatsSuccess({
            seats: response.seats,
            stats: response.stats,
        }));
    } catch (error) {
        yield put(getExamRoomSeatsFail(error));
    }
}

function* resetExamRoomSeatsSaga({ payload: uuid }) {
    try {
        yield call(resetExamRoomSeats, uuid);
        yield put(resetExamRoomSeatsSuccess());
        yield put(getExamRoomAssignments());
    } catch (error) {
        yield put(resetExamRoomSeatsFail(error));
    }
}


function* examRoomAssignmentSaga() {
    yield takeEvery(GET_EXAM_ROOM_ASSIGNMENTS, fetchExamRoomAssignments)
    yield takeEvery(ADD_NEW_EXAM_ROOM_ASSIGNMENT, onAddNewExamRoomAssignment)
    yield takeEvery(UPDATE_EXAM_ROOM_ASSIGNMENT, onUpdateExamRoomAssignment)
    yield takeEvery(DELETE_EXAM_ROOM_ASSIGNMENT, onDeleteExamRoomAssignment)
    
    yield takeEvery(GENERATE_EXAM_ROOM_SEATS,         generateExamRoomSeatsSaga);
    yield takeEvery(GET_EXAM_ROOM_SEATS,              getExamRoomSeatsSaga);
    yield takeEvery(RESET_EXAM_ROOM_SEATS,            resetExamRoomSeatsSaga);
}

export default examRoomAssignmentSaga;